import { fetchTeams } from '../services/api';
import { TEAMS_QUERY_KEY } from '../constants';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { TeamListItem } from '../types';
import { useAuthStore } from '@modules/auth/store';

function useQueryTeams(): UseQueryResult<TeamListItem[]> {
  const { user } = useAuthStore();
  return useQuery(
    [TEAMS_QUERY_KEY],
    async () => {
      if (user === null) {
        return await new Promise((resolve) => resolve([]));
      }
      return await fetchTeams(user);
    },
    {
      enabled: user !== null,
    },
  );
}

export default useQueryTeams;
